// Internal
import en from "../../../data/en.json";

export type NavLink = {
  kind: "link";
  id: string;
  label: string;
  href: string;
  /** "self" for #hash targets (same-page smooth scroll), "blank" otherwise. */
  target: "self" | "blank";
};

export type NavGroup = {
  kind: "group";
  id: string;
  label: string;
  children: NavLink[];
};

export type NavItem = NavLink | NavGroup;

const link = (
  id: string,
  label: string,
  href: string,
  target: "self" | "blank" = "blank"
): NavLink => ({ kind: "link", id, label, href, target });

export const primaryNav: NavItem[] = [
  link("about", en.marketing.about, "/about"),
  {
    kind: "group",
    id: "services",
    label: en.marketing.features,
    children: [
      link("essaycraft", "EssayCraft AI", "/features#essaycraft", "self"),
      link(
        "inkbowl-publishing",
        "InkBowl Publishing",
        "/features#inkbowl-publishing",
        "self"
      ),
      link("inklink-network", "InkLink Network", "/features#inklink", "self"),
      link("versecanvas", "VerseCanvas AI", "/features#versecanvas", "self"),
    ],
  },
  {
    kind: "group",
    id: "publishing",
    label: en.common.publishing,
    children: [
      link("digital-archive", "Publication Archive", "/digital-archive"),
      link("publishing-about", "About", "/publishing"),
      link("submissions", "Submissions", "/submissions"),
    ],
  },
  link("inklink", en.marketing.inkLink, "/community"),
  {
    kind: "group",
    id: "more",
    label: en.marketing.learnMore,
    children: [link("guidelines", "Community Guidelines", "/guidelines")],
  },
];

export function buildAccountNav(opts: {
  isAuthenticated: boolean;
  isAdmin: boolean;
}): NavLink[] {
  if (!opts.isAuthenticated) return [];

  const items = [link("dashboard", en.common.dashboard, "/dashboard")];
  if (opts.isAdmin) items.push(link("admin", "Admin", "/admin"));
  return items;
}

export const navigateTo = (item: NavLink) => {
  if (item.target === "self") {
    window.location.href = item.href;
  } else {
    window.open(item.href);
  }
};
